// Import Vue
import Vue from 'vue';

// Import F7
import Framework7 from 'framework7/dist/framework7.esm.bundle.js';

// Import F7 Vue Plugin
import Framework7Vue from 'framework7-vue/dist/framework7-vue.esm.bundle.js';

// Import F7 Styles
import Framework7Styles from 'framework7/dist/css/framework7.css';

// Import Icons and App Custom Styles
import IconsStyles from './css/icons.css';
import AppStyles from './css/app.css';

// Import Routes
import Routes from './routes.js'

// Import App Component
import App from './app';

// Import axios
import axios from 'axios-jsonp-pro'

// Init F7 Vue Plugin
Vue.use(Framework7Vue, Framework7)

// Axios
Vue.prototype.$http = axios

// API URI
Vue.prototype.$api_base_uri = 'http://api.jejucommerce.com/pos';

// Init App
new Vue({
  el: '#app',
  template: '<app/>',
  // Init Framework7 by passing parameters here
  framework7: {
    id: 'com.jejucommerce.mobilepos', // App bundle ID
    name: 'Mobile POS', // App name
    version: '1.0.0',
    theme: 'auto', // Automatic theme detection
    // App routes
    routes: Routes,
  },
  // Register App Component
  components: {
    app: App
  },
  // Root Data
  data() {
    return {
      login_id: '',
      login_name: '',
      group_code: '',
      tourist_id: '',
      admin_tourist_name: '미선택',
      use_barcode_limit_yn: true,
      auto_login: true,
      last_modified_date: '2018.07.04'
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js